import { render, staticRenderFns } from "./ItemFilterDefaultLayout.vue?vue&type=template&id=653919b6&scoped=true&"
import script from "./ItemFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653919b6",
  null
  
)

export default component.exports